// removed by extract-text-webpack-plugin
module.exports = {"nav":"_3yjyx18t829kn7k1mdsdf694yefmwt8h3euyf97brqkkf542jn7af5ayqhc59cm16tf1vupanjbaqn2q1w1kennyg5x55mc3pwj14z6-ReportEdit-module-nav","objects--grid--item--img":"p8yymh2n77719ye74jtn58gweskdq8w3ue3rnakxt3dzr7njwmkej6w41ckrdcabr4c9qbgrx7mrb7bdgmf3yrc88dqtj3xvp73j5j-ReportEdit-module-objects--grid--item--img","img":"_2sry9m6memcsm19pd5bvbzb9rpp4rjfuaregg67g8rsmbnqqzbndma5k5j2vxr7kycpqfsybg38mmbc228x2et2p7nxa8n3m991kzsh-ReportEdit-module-img"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ReportEdit/ReportEdit.module.scss
// module id = 618
// module chunks = 0